'use client';

import { useEffect } from 'react';

import { trackPageView } from '@/lib/analytics';

interface ArticlePageViewTrackerProps {
  articleId: string;
}

/**
 * Client component to track article page views
 * Should be included in the article page to track when users view the full article
 */
export function ArticlePageViewTracker({ articleId }: ArticlePageViewTrackerProps) {
  useEffect(() => {
    // Track page view when component mounts
    trackPageView(articleId);
  }, [articleId]);

  // This component doesn't render anything
  return null;
}
